import React from 'react'
export type MixpanelEventLocationContextType = {
  featureContext: 'showcases' | null
}
export const MixpanelEventLocationContext: React.Context<MixpanelEventLocationContextType> =
  React.createContext<MixpanelEventLocationContextType>({
    featureContext: null,
  })
export const MixpanelEventLocationProvider =
  MixpanelEventLocationContext.Provider
